import React, { Component } from 'react';
import { Button, Modal, Header, Segment, Icon } from 'semantic-ui-react';
import orderBy from 'lodash/orderBy';
import { EnjoyIcon, getProfileAvatar } from '@emyw/core-lib';
import EditProfileForm from './EditProfileForm';
import ManageSocialNetworkForm from '../ManageSocialNetworkForm';
import DeleteProfile from './DeleteProfile';
import AvatarEditor from '../AvatarEditor';
import ButtonLink from '../ButtonLink';
import './ManageProfiles.css';
import '../primitives.css';
export default class ManageProfiles extends Component {
  constructor(props, context) {
    super(props, context);
    this.openEditorModal = (profile, newProfile) => {
      // log.trace('opening manage profile. this.mounted:', this.mounted);
      if (this.mounted) {
        this.setStateWrapper({
          selectedProfile: profile,
          profileModalOpen: true,
          modalTitle: newProfile ? 'New Profile' : 'Manage Profile',
          oldAvatarInCaseOfDiscard: null
        });
      }
    };
    this.setStateWrapper = (newState, cb) => {
      if (this.mounted) this.setState(newState, cb);
      // log.trace('this.state:', this.state);
    };
    this.openSocialModal = profile => this.setStateWrapper({
      selectedProfile: profile,
      socialModalOpen: true,
      oldAvatarInCaseOfDiscard: null
    });
    this.openDeleteModal = profile => this.setStateWrapper({
      selectedProfile: profile,
      deleteModalOpen: true
    });
    this.closeManageModal = (submitted, id) => {
      this.setStateWrapper({
        selectedProfile: undefined,
        newAvatar: undefined,
        profileModalOpen: false,
        modalTitle: 'Manage Profile'
      });
      if (submitted) {
        if (this.props.onSubmit) this.props.onSubmit(id);else log.warn('onSubmit prop required but not provided');
      } else if (this.props.onDiscard) {
        const {
          user
        } = this.props;
        const {
          oldAvatarInCaseOfDiscard,
          selectedProfile
        } = this.state;
        user.Profiles = user.Profiles.map(profile => {
          if (profile.id === selectedProfile.id && oldAvatarInCaseOfDiscard) {
            return {
              ...profile,
              avatarUrl: oldAvatarInCaseOfDiscard
            };
          }
          return profile;
        });
        this.props.onDiscard();
      } else {
        log.warn('onDiscard prop required but not provided');
      }
    };
    this.closeSocialModal = () => {
      this.setStateWrapper({
        selectedProfile: undefined,
        socialModalOpen: false
      });
    };
    this.closeDeleteModal = (confirmed, id) => {
      this.setStateWrapper({
        selectedProfile: undefined,
        deleteModalOpen: false
      });
      if (confirmed) {
        if (this.props.onDelete) this.props.onDelete(id);else log.warn('onDelete prop required but not provided');
      }
    };
    this.openAvatarEditor = () => this.setStateWrapper({
      avatarEditorOpen: true
    });
    this.closeAvatarEditor = () => this.setStateWrapper({
      avatarEditorOpen: false
    });
    this.handleAvatarUpdate = updatedAvatar => {
      const {
        user
      } = this.props;
      const {
        selectedProfile
      } = this.state;
      // log.trace('receiving new avatar', updatedAvatar);
      // I know this is terrible as it mutates state, but the way we set this up made this the simplest way to reflect
      // the new avatar without reloading the page.
      let oldAvatarInCaseOfDiscard;
      user.Profiles = user.Profiles.map(profile => {
        if (profile.id === selectedProfile.id && updatedAvatar) {
          oldAvatarInCaseOfDiscard = profile.avatarUrl;
          return {
            ...profile,
            avatarUrl: updatedAvatar
          };
        }
        return profile;
      });
      this.setStateWrapper({
        newAvatar: updatedAvatar,
        selectedProfile: {
          ...this.state.selectedProfile,
          avatarUrl: updatedAvatar
        },
        oldAvatarInCaseOfDiscard
      });
    };
    this.state = {
      selectedProfile: undefined,
      newAvatar: undefined,
      profileModalOpen: false,
      socialModalOpen: false,
      deleteModalOpen: false,
      avatarEditorOpen: false,
      modalTitle: 'Manage Profile'
    };
    this.mounted = false;
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentDidUpdate(prevProps) {
    // log.trace('//////// updated. this:', this);
    const {
      autoOpenProfile
    } = this.props;
    if (autoOpenProfile && autoOpenProfile.id !== (prevProps.autoOpenProfile || {}).id) {
      // console.log('setting ', autoOpenProfile);
      this.openEditorModal(autoOpenProfile);
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      selectedProfile,
      newAvatar,
      profileModalOpen,
      avatarEditorOpen,
      socialModalOpen,
      deleteModalOpen,
      modalTitle
    } = this.state;
    const {
      user,
      preferenceContent
    } = this.props;
    const userProfiles = orderBy(user.Profiles, ['id'], ['asc']);
    log.trace('selectedProfile:', selectedProfile);
    return /*#__PURE__*/React.createElement("div", {
      className: "manageProfiles"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
      color: "blue",
      attached: "top"
    }, /*#__PURE__*/React.createElement(EnjoyIcon, {
      className: "formTitleIcon"
    }), " \xA0 Manage Profiles"), /*#__PURE__*/React.createElement(Segment, {
      attached: "bottom"
    }, userProfiles.map((profile, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: index.toString()
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle spaced"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol middle",
      style: {
        width: '160px',
        margin: '4px 0'
      }
    }, /*#__PURE__*/React.createElement(ButtonLink, {
      className: "profile_avatar_button",
      onClick: () => this.openEditorModal(profile)
    }, getProfileAvatar({
      profile,
      iconSize: 'huge',
      imgOnError: e => {
        e.persist();
        setTimeout(() => {
          e.target.src = e.target.src;
        }, 1000);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_name"
    }, profile.name)), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol paddedLight",
      style: {
        margin: '4px 30px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      onClick: () => this.openEditorModal(profile),
      basic: true,
      color: "blue"
    }, "Manage")), /*#__PURE__*/React.createElement("div", {
      className: "fixedRow"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      onClick: () => this.openSocialModal(profile),
      basic: true,
      color: "teal"
    }, "Social Link")), /*#__PURE__*/React.createElement("div", {
      className: "fixedRow"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: () => this.openDeleteModal(profile),
      disabled: !index,
      color: "grey",
      basic: true
    }, "Delete")))), /*#__PURE__*/React.createElement("div", {
      className: "fixedDivider padded"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "fixedRow middle spaced"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedCol middle",
      style: {
        width: '160px',
        margin: '4px 0'
      }
    }, /*#__PURE__*/React.createElement(ButtonLink, {
      className: "profile_avatar_button",
      onClick: () => this.openEditorModal({
        userId: user.id
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "profile_avatar new",
      color: "grey",
      size: "huge",
      name: "add user",
      bordered: true,
      inverted: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_name"
    }, "New")), /*#__PURE__*/React.createElement("div", {
      className: "fixedCol",
      style: {
        margin: '4px 30px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "fixedRow"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      onClick: () => this.openEditorModal({
        userId: user.id,
        contentPINRestricted: 'NONE'
      }, true),
      color: "blue",
      basic: true
    }, "New Profile")))))), /*#__PURE__*/React.createElement(Modal, {
      className: "manageProfileModal",
      open: profileModalOpen,
      closeOnDimmerClick: false
    }, /*#__PURE__*/React.createElement(Modal.Header, null, modalTitle), /*#__PURE__*/React.createElement(Modal.Content, null, Boolean(selectedProfile) && /*#__PURE__*/React.createElement(EditProfileForm, {
      profile: selectedProfile,
      newAvatarUrl: newAvatar,
      onClose: this.closeManageModal,
      onChangePicture: this.openAvatarEditor,
      PreferenceContent: preferenceContent ? preferenceContent(selectedProfile.id) : null,
      enablePINSettings: Boolean((user || {}).pin)
    }))), /*#__PURE__*/React.createElement(Modal, {
      open: socialModalOpen,
      closeOnDimmerClick: false,
      size: "tiny",
      className: "socialModal"
    }, /*#__PURE__*/React.createElement(Modal.Header, null, "Social Networks"), /*#__PURE__*/React.createElement(Modal.Content, null, Boolean(selectedProfile) && /*#__PURE__*/React.createElement(ManageSocialNetworkForm, {
      profile: selectedProfile,
      onUpdate: this.handleAvatarUpdate
      // onClose={this.closeManageModal}
    }), /*#__PURE__*/React.createElement(Button, {
      className: "modalOkButton",
      type: "submit",
      onClick: this.closeSocialModal,
      basic: true,
      color: "blue",
      fluid: true
    }, "OK"))), /*#__PURE__*/React.createElement(Modal, {
      open: deleteModalOpen,
      closeOnDimmerClick: false,
      size: "tiny",
      className: "enjoyModal"
    }, /*#__PURE__*/React.createElement(Modal.Header, null, "Delete Profile"), /*#__PURE__*/React.createElement(Modal.Content, null, Boolean(selectedProfile) && /*#__PURE__*/React.createElement(DeleteProfile, {
      profile: selectedProfile,
      onClose: this.closeDeleteModal
    }))), /*#__PURE__*/React.createElement(AvatarEditor, {
      profile: selectedProfile,
      open: avatarEditorOpen,
      onClose: this.closeAvatarEditor,
      onAvatarUpdate: this.handleAvatarUpdate
    }));
  }
}
ManageProfiles.defaultProps = {
  autoOpenProfile: undefined
};